import { t } from "@/i18n-js/instance";
import videoPreview from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/VideoBlock/video_preview.png";
import { Form } from "@circle-react-uikit/Form";
import { ReplaceMediaButton } from "../ReplaceMediaButton";
import { UploadMediaButton } from "../UploadMediaButton";
import type { InlineAttachment } from "./useMediaPicker";
import { useMediaPicker } from "./useMediaPicker";

export interface MediaPickerProps {
  file: InlineAttachment;
  onClickRemove: () => void;
  onUploadComplete: (file: InlineAttachment) => void;
  onUploadStarted: () => void;
}

export const MediaPicker = ({
  file,
  onUploadStarted,
  onUploadComplete,
  onClickRemove,
}: MediaPickerProps) => {
  const { progress, isUploading, getRootProps, getInputProps, onSelectFile } =
    useMediaPicker({
      onUploadStarted,
      onUploadComplete,
    });

  return (
    <>
      <input {...getInputProps()} />
      <Form.Item
        label={t("builder_ui.prop_type.video_upload.video_file")}
        hideDescription
        hideBorder
        className="!p-0"
      >
        {file?.url ? (
          <ReplaceMediaButton
            filename={file.filename}
            onClickReplace={onSelectFile}
            onClickRemove={onClickRemove}
            thumbnailUrl={
              file.thumbnail_url ? file.thumbnail_url : videoPreview
            }
          />
        ) : (
          <UploadMediaButton
            progress={progress}
            isUploading={isUploading}
            onSelectFile={onSelectFile}
            getRootProps={getRootProps}
            ariaLabel={t("builder_ui.prop_type.video_upload.add_video")}
            uploadingText={t(
              "builder_ui.prop_type.video_upload.uploading_video",
            )}
          />
        )}
      </Form.Item>
    </>
  );
};
